import { render, staticRenderFns } from "./attached-file-viewer.vue?vue&type=template&id=5fabc05d&scoped=true"
import script from "./attached-file-viewer.vue?vue&type=script&lang=ts"
export * from "./attached-file-viewer.vue?vue&type=script&lang=ts"
import style0 from "./attached-file-viewer.vue?vue&type=style&index=0&id=5fabc05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fabc05d",
  null
  
)

export default component.exports